var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "confirm-email" }, [
    _c(
      "div",
      { staticClass: "center" },
      [
        _c("h1", [_vm._v(_vm._s(_vm.$t("confirmEmailPage.title")))]),
        _c("p", [_vm._v(_vm._s(_vm.$t("confirmEmailPage.description")))]),
        _c("text-field", {
          attrs: {
            label: _vm.$t("confirmEmailPage.passwordLabel"),
            type: "password",
          },
          model: {
            value: _vm.password,
            callback: function ($$v) {
              _vm.password = $$v
            },
            expression: "password",
          },
        }),
        _c("div", { staticClass: "attention" }, [
          _vm._v(_vm._s(_vm.$t("confirmEmailPage.passwordRequirement"))),
        ]),
        _c(
          "button",
          {
            staticClass: "enrollment-button",
            attrs: { disabled: _vm.password.length < 7 },
            on: { click: _vm.confirmEmail },
          },
          [_vm._v(" " + _vm._s(_vm.$t("confirmEmailPage.submitButton")) + " ")]
        ),
        _vm.errorMessage
          ? _c("div", { staticClass: "error-message" }, [
              _vm._v(_vm._s(_vm.errorMessage)),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }